const PriceFeatures = ({content}) => {
    return (
        <div className={'pricing-lists'}>
            <ul className={'pricing-list'}>
                {content?.features.map((feature, index) => (
                    <li key={`${feature}-${index}`}>
                        <span aria-hidden="true" className="material-symbols-outlined">task_alt</span>
                        {feature}
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default PriceFeatures